import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput, DropdownInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { checkDateSet } from "data/lib/dates"

import { FormError_s } from "styles/form-styles"
import { SingleRowCarouselState_s, MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const BreakpointDetailed = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyStatic = {
    amtType: props.defaults['salesAmtType']
  }

  const emptyRecord = {
    date: null,
    amt: null,
  }

  const [data, setData] = useState<object|null>(props.rowData[props.field])
  const [items, setItems] = useState<Item_t[]>(initialItems && initialItems.length ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyRecord, i: 0}]);
  const [homogenous, setHomogenous] = useState<boolean>(true);

  function updateData(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data || {})

    _.set(newData, field, val)
    if(newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    if(!newData.items) _.set(newData, 'items', [])

    delete newData.amt
    delete newData.breakPoint

    setData(newData)
    props.persist(newData, props.field, props.rowData)
  }

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data || {})

    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val
    if (field[1] === 'date') {
      let dateModeCheck = checkDateSet(val, items)
      setHomogenous(dateModeCheck.homogenous)
      _.set(newData, 'dateMode', dateModeCheck.dateMode)
    }
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')

    delete newData.amt
    delete newData.breakPoint

    setData(newData)
    props.persist(newData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data);
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date");
    _.set(newData, 'items', strippedItems);
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed');
    props.persist(newData, 'breakpointdetail', props.rowData);
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if(_.get(props, 'rowData.breakpointdetail.state') !== 'detailed'){
      setData(emptyStatic)
      setItems([{...emptyRecord, i: 0}]);
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('rentroll', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated"
            data={data}
            attrs={attrs}
            default={props.defaults['salesAmtType']}
            options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
            persist={updateData}
          />
        </div>
      </SingleRowCarouselState_s>
      <br/>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div style={{width: '158px'}}>
              { i === 0 && <label>Date</label> }
              <DateInput className="automated" attrs={attrs} field={[`${row['i']}`, 'date']} {...params} allowRelative />
            </div>
            <div style={{width: '158px'}}>
              { i === 0 && <label>Amt</label> }
              <NumberInput className="automated" attrs={attrs} field={[`${row['i']}`, 'amt']} {...params} readPrecision={4} writePrecision={4} trailingZeros={false}/>
            </div>
            <RowAddRemove emptyRecord={emptyRecord} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
      {!homogenous && <FormError_s>All dates must be either relative or absolute</FormError_s>}
    </div>
  )
}

export default BreakpointDetailed
